/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DisplayBatteryManagementToggle_DisplayFragment = { __typename: 'Display', id: string, battery?: { __typename: 'BatteryState', desired?: { __typename: 'BatteryDesired', powerManagement: string } | null, reported: { __typename: 'Battery', powerManagement: string } } | null };

export type BulkUpdateBatteryPowerManagementMutationVariables = Types.Exact<{
  input: Types.DisplayBulkUpdateBatteryPowerManagementInput;
}>;


export type BulkUpdateBatteryPowerManagementMutation = { __typename: 'Mutation', displayBulkUpdateBatteryPowerManagement: { __typename: 'DisplayBulkUpdateBatteryPowerManagementPayload', displays: Array<{ __typename: 'Display', id: string, battery?: { __typename: 'BatteryState', desired?: { __typename: 'BatteryDesired', powerManagement: string } | null, reported: { __typename: 'Battery', powerManagement: string } } | null }> } };

export const DisplayBatteryManagementToggle_DisplayFragmentDoc = gql`
    fragment DisplayBatteryManagementToggle_display on Display {
  id
  battery {
    desired {
      powerManagement
    }
    reported {
      powerManagement
    }
  }
}
    `;
export const BulkUpdateBatteryPowerManagementDocument = gql`
    mutation BulkUpdateBatteryPowerManagement($input: DisplayBulkUpdateBatteryPowerManagementInput!) {
  displayBulkUpdateBatteryPowerManagement(input: $input) {
    displays {
      id
      ...DisplayBatteryManagementToggle_display
    }
  }
}
    ${DisplayBatteryManagementToggle_DisplayFragmentDoc}`;
export type BulkUpdateBatteryPowerManagementMutationFn = ApolloReactCommon.MutationFunction<BulkUpdateBatteryPowerManagementMutation, BulkUpdateBatteryPowerManagementMutationVariables>;

/**
 * __useBulkUpdateBatteryPowerManagementMutation__
 *
 * To run a mutation, you first call `useBulkUpdateBatteryPowerManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateBatteryPowerManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateBatteryPowerManagementMutation, { data, loading, error }] = useBulkUpdateBatteryPowerManagementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateBatteryPowerManagementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUpdateBatteryPowerManagementMutation, BulkUpdateBatteryPowerManagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkUpdateBatteryPowerManagementMutation, BulkUpdateBatteryPowerManagementMutationVariables>(BulkUpdateBatteryPowerManagementDocument, options);
      }
export type BulkUpdateBatteryPowerManagementMutationHookResult = ReturnType<typeof useBulkUpdateBatteryPowerManagementMutation>;
export type BulkUpdateBatteryPowerManagementMutationResult = ApolloReactCommon.MutationResult<BulkUpdateBatteryPowerManagementMutation>;
export type BulkUpdateBatteryPowerManagementMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUpdateBatteryPowerManagementMutation, BulkUpdateBatteryPowerManagementMutationVariables>;